import React from 'react'
import './Header.css'

function Header() {
	return (
		<h1 className="header">Mega TicTacToe</h1>
	)
}

export default Header;